import React, {Component} from 'react'
import DocumentTitle from 'react-document-title'
import Cta from './Cta'

import style from './faq.sass'

class Faq extends Component {
  render() {
    return(
      <div>
        <DocumentTitle title='FAQ'/>
        <div styleName='banner'>
          <h3>Frequently Asked Questions</h3>
        </div>
        <section className='bg-white'>
          <div className='landing-container' styleName='container'>
            <h3>How much time does it take to setup my account?</h3>
            <p>You can start building strategies immediately once you sign up.</p>
            <hr/>

            <h3>How can I learn how to use the platform?</h3>
            <p>
              There are tutorial videos available once you sign up. The interface
              itself is very intuitive and it only requires you to type your strategies in English.
            </p>
            <hr/>

            <h3>What if I don&apos;t know much about quantitative analysis and Algorithmic trading?</h3>
            <p>
              Our platform is designed for discretionary traders and fundamental fund managers
              without quantitative/programming skills. Although our users are professional traders,
              most of them have very limited or zero experience with Algorithmic trading.
            </p>
            <hr/>

            <h3>Are my strategies secure on Algoriz? Does Algoriz share my ideas or trades with them?</h3>
            <p>
              Your strategies are kept in a secure database. We never share your strategies with anyone
              or use them ourselves. That is part of the agreement that we sign with you before you sign up.
            </p>
            <hr/>

            <h3>How accurate is Algoriz in understanding my strategies?</h3>
            <p>
              Algoriz uses the latest technology to understand human language, but there are still
              circumstances where English is ambiguous. In such cases, Algoriz confirms the true meaning
              with you before building the strategy.
            </p>
            <hr/>

            <h3>How do you take the effect of slippage into account in your backtesting?</h3>
            <p>
              Algoriz is leveraging a sophisticated slippage model that takes liquidity, order size, etc.
              into account to estimate the slippage paid in real trading.
            </p>
            <hr/>

            <h3>Which asset classes does your platform support?</h3>
            <p>
              Algoriz is currently supporting equities trading. We are working on adding FX and
              commodities to the platform.
            </p>
            <hr/>

            <h3>How I can contact you?</h3>
            <p>
              Send us a message at <a href='mailto:info@algoriz.com'>info@algoriz.com</a>
            </p>
          </div>
        </section>
        <Cta/>
      </div>
    )
  }
}

export default Faq
